module.exports = __webpack_public_path__ + "static/media/img_default.7b2cc977.png";